import { memo } from 'react';

const Footer = () => {
  return (
    <footer className="sticky-footer bg-white">
      <div className="container my-auto">
        <div className="copyright text-center my-auto">
          <span>Copyright &copy; iHealthScreen</span>
          <span className="float-right font-italic for-help">
            For Help:
            <i className="fas fa-phone-alt"></i>
            <span>01335-134373</span>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default memo(Footer);
